import { render, staticRenderFns } from "./formClassArrear.vue?vue&type=template&id=d5643fee&scoped=true&"
import script from "./formClassArrear.vue?vue&type=script&lang=js&"
export * from "./formClassArrear.vue?vue&type=script&lang=js&"
import style0 from "./formClassArrear.vue?vue&type=style&index=0&id=d5643fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5643fee",
  null
  
)

export default component.exports